/**
 * Home page “latest release” promo. Update when you ship a new version
 * (keep in sync with the first entry in ReleasesSection and the release file).
 */
export const latestReleaseHome = {
  version: 'v1.12.0',
  /** Same style as the release sidebar: dd/Mmm/yyyy or TBC */
  date: '12th October 2026',
  title: 'Share the action, invite your crew & never lose your game!',
  /** One or two sentences for the summary card */
  summary:
    'Invite codes, instant game sharing, shareable reports, and a ton of polish to keep you connected to the action.',
  /** Optional short bullets (omit or leave empty [] if you only want the summary) */
  highlights: [
    'Invite codes for private venues, share games & reports with a link, quick game stays on Home',
  ],
};
